module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"prefixText":"","suffixText":"","linkTitle":""},"ja":{"prefixText":"詳細は","suffixText":"を参照下さい。","linkTitle":"ヘルプサイト"},"zh-hant":{"prefixText":"","suffixText":"","linkTitle":""},"zh-hans":{"prefixText":"","suffixText":"","linkTitle":""}}')
  delete Component.options._Ctor
}
